<template>
  <b-card header-tag="header" class="m-3" no-body>
    <template #header>
      <HeaderSagres titulo="Últimas execuções do Invoker">
        <template #customContent>
          <div class="d-flex flex-wrap align-items-center justify-content-end">
            <GeradorDeHash />
            <b-button @click="modalAberto=true">
              <font-awesome-icon icon="plus" />
              Criar Requisição
            </b-button>
          </div>
        </template>
      </HeaderSagres>
    </template>
    <b-card-body class="p-0">
      <b-table :fields="fields" :items="listaAvaliacoes" :busy="loadingAvaliacoes" hover no-border-collapse sort-by=""
        :sort-desc="true" striped stacked="xl" show-empty>
        <template #empty>
          <span>Não foram encontrados dados.</span>
        </template>
        <template #emptyfiltered>
          <span>Não foram encontrados dados.</span>
        </template>
        <template #table-busy>
          <div class="text-center text-dark">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="loading-text">Carregando...</strong>
          </div>
        </template>
        <!-- TODO: Isso é copiado de DetalhesLotesItens.vue, e deve haver outros por aí. Dá pra centralizar o visual num componente passando as variáveis por prop/emit, e tbm dá pra centralizar o table-field usado -->
        <template v-slot:cell(respostas)="row">
          <b-link class="text-dark" @click="row.toggleDetails">
            <font-awesome-icon :icon="row.detailsShowing ? 'chevron-up' : 'chevron-down'" />
          </b-link>
        </template>
        <template #row-details="row">
          <TabelaRespostas :avaliacao="row.item" />
        </template>
        <template v-slot:cell(dsSituacao)="row">
          <span class="badge sitBadge" :class="row.item.classSituacao">
            {{ row.item.dsSituacao }}
          </span>
        </template>
      </b-table>
    </b-card-body>

    <ModalAddRequisicaoInvoker v-if="modalAberto" @fecharModal="closeModal"/>
  
  </b-card>
</template>

<script lang="ts">
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { Component, Vue } from "vue-property-decorator";
import serigyService from "@/services/administracao/serigyService";
import HeaderSagres from "@/components/shared/HeaderSagres.vue";
import { Avaliacao } from "@/types/administracao/serigy/invoker/avaliacao";
import { fieldsAvaliacoes } from "@/types/administracao/serigy/invoker/fields-invoker-avaliacoes";
import { TableField } from "@/types/table-field";
import TabelaRespostas from "@/components/serigy/TabelaRespostas.vue";
import GeradorDeHash from "@/components/serigy/GeradorDeHash.vue";
import ModalAddRequisicaoInvoker from "@/components/serigy/ModalAddRequisicaoInvoker.vue";

const CompProps = Vue.extend({
  name: "Invoker",
  components: {
    GeradorDeHash,
    HeaderSagres,
    TabelaRespostas,
    ModalAddRequisicaoInvoker,
  },
});

@Component
export default class Invoker extends mixins(UtilsTS, CompProps) {
  fields: TableField[] = fieldsAvaliacoes;
  listaAvaliacoes: Avaliacao[] = [];
  loadingAvaliacoes = false;
  modalAberto = false

  closeModal(refresh = false): void {
    if (refresh) this.loadData()
    this.modalAberto = false
  }

  async loadData(): Promise<void> {
    try {
      this.loadingAvaliacoes = true;
      this.listaAvaliacoes = await serigyService.listarAvaliacoes();
    } catch (error) {
      this.tratarError(error);
      this.listaAvaliacoes = [];
    } finally {
      this.loadingAvaliacoes = false;
    }
  }

  async onNovaAvaliacao(novaAvaliacao: Avaliacao): Promise<void> {
    try {
      this.loadingAvaliacoes = true
      this.listaAvaliacoes.unshift(novaAvaliacao)
    } finally {
      this.loadingAvaliacoes = false
    }
  }

  async mounted(): Promise<void> {
    this.loadData();
  }
}
</script>
<style scoped>
span.sitBadge.success {
  color: #fff;
  background-color: #28a745;
}

span.sitBadge.warning {
  background-color: #ffc107;
}

span.sitBadge.danger {
  color: #fff;
  background-color: #dc3545;
}
</style>
